import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiShoppingCart, FiPrinter, FiEdit3 } from 'react-icons/fi';

const steps = [
  {
    icon: FiShoppingCart,
    title: '1. Buy Once',
    description: 'Purchase your dynamic QR code for a single, flat fee. No subscriptions, no hidden costs. It is yours forever.'
  },
  {
    icon: FiPrinter,
    title: '2. Print Everywhere',
    description: 'Download your high-res QR code and print it on menus, flyers, billboards, or business cards. You never have to reprint it.'
  },
  {
    icon: FiEdit3,
    title: '3. Update Anytime',
    description: 'Log into your dashboard and change where the QR code points to instantly. The physical code stays exactly the same.'
  }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="w-full py-24 px-6 bg-[#f8f8f8] border-b-4 border-black">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-16 text-center">
          How It Works
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="bg-white border-4 border-black p-8 brutal-shadow flex flex-col items-start"
            >
              <div className="w-16 h-16 bg-black text-white flex items-center justify-center mb-6">
                <SafeIcon icon={step.icon} className="w-8 h-8" />
              </div>
              <h3 className="text-2xl font-black uppercase mb-4">{step.title}</h3>
              <p className="font-medium text-lg leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;